module.exports = __webpack_public_path__ + "static/media/big_tower_pattern.61293dfc.png";